import React from 'react'

const DeclinedPopupIcon = () => {
  return (
    <div>
      <svg
        width="56"
        height="68"
        viewBox="0 0 56 68"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect y="12" width="56" height="56" rx="28" fill="#FFF0F0" />
        <mask
          id="mask0_1199_19931"
          maskUnits="userSpaceOnUse"
          x="16"
          y="28"
          width="24"
          height="24"
        >
          <rect x="16" y="28" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_1199_19931)">
          <path
            d="M23.7 44.3C23.8833 44.4833 24.1167 44.575 24.4 44.575C24.6833 44.575 24.9167 44.4833 25.1 44.3L28 41.4L30.925 44.325C31.1083 44.5083 31.3377 44.5957 31.613 44.587C31.8877 44.579 32.1167 44.4833 32.3 44.3C32.4833 44.1167 32.575 43.8833 32.575 43.6C32.575 43.3167 32.4833 43.0833 32.3 42.9L29.4 40L32.325 37.075C32.5083 36.8917 32.5957 36.6623 32.587 36.387C32.579 36.1123 32.4833 35.8833 32.3 35.7C32.1167 35.5167 31.8833 35.425 31.6 35.425C31.3167 35.425 31.0833 35.5167 30.9 35.7L28 38.6L25.075 35.675C24.8917 35.4917 24.6627 35.404 24.388 35.412C24.1127 35.4207 23.8833 35.5167 23.7 35.7C23.5167 35.8833 23.425 36.1167 23.425 36.4C23.425 36.6833 23.5167 36.9167 23.7 37.1L26.6 40L23.675 42.925C23.4917 43.1083 23.4043 43.3373 23.413 43.612C23.421 43.8873 23.5167 44.1167 23.7 44.3ZM28 50C26.6167 50 25.3167 49.7373 24.1 49.212C22.8833 48.6873 21.825 47.975 20.925 47.075C20.025 46.175 19.3127 45.1167 18.788 43.9C18.2627 42.6833 18 41.3833 18 40C18 38.6167 18.2627 37.3167 18.788 36.1C19.3127 34.8833 20.025 33.825 20.925 32.925C21.825 32.025 22.8833 31.3123 24.1 30.787C25.3167 30.2623 26.6167 30 28 30C29.3833 30 30.6833 30.2623 31.9 30.787C33.1167 31.3123 34.175 32.025 35.075 32.925C35.975 33.825 36.6873 34.8833 37.212 36.1C37.7373 37.3167 38 38.6167 38 40C38 41.3833 37.7373 42.6833 37.212 43.9C36.6873 45.1167 35.975 46.175 35.075 47.075C34.175 47.975 33.1167 48.6873 31.9 49.212C30.6833 49.7373 29.3833 50 28 50Z"
            fill="#EB5D60"
          />
        </g>
      </svg>
    </div>
  )
}

export default DeclinedPopupIcon
